<template>
  <div>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">QuickNotice</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_nuovo_ev = true"
            small
            v-bind="attrs"
            v-on="on"
            class="mr-5"
          >
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Aggiungi evento</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <ListaEventi ref="lista"/>
      </v-card-text>
    </v-card>

    <!-- Dialog di aggiunta evento -->
    <v-dialog v-model="dialog_nuovo_ev" persistent>
      <NuovoModifica
        :key="dialog_nuovo_ev"
        @click_chiudi="dialog_nuovo_ev = false; refresh()"
        :nuovo="true"
        @salvataggio_effettuato="refresh()"
      />
    </v-dialog>
  </div>
</template>


<script>
import ListaEventi from "@/components/QNOTICE/ListaEventi.vue";
import NuovoModifica from "@/components/QNOTICE/NuovoModifica.vue";

export default {
  name: "QNotice",
  components: { ListaEventi, NuovoModifica },
  props: {},
  data() {
    return {
      //Variabili di supporto

      //Modali

      dialog_nuovo_ev: false,

      //Array
    };
  },

  methods: {
    clickIndietro() {
      this.$router.push("/home/notice");
    },

    refresh(){
      this.$refs.lista.getEventi();
    }
  },

  computed: {},

  watch: {},

  mounted() {},
};
</script>
<style scoped>
</style>